import {
  CRM_GMAIL_OAUTH_PENDING_REDIRECT_KEY,
  CRM_GMAIL_OAUTH_RESULT_PENDING_KEY,
  getStorageItem,
  saveItemToStorage,
} from "@jugl-web/utils/storage";

// Runs at app boot, before React Router can <Navigate> away and strip the OAuth
// callback query string. The Gmail OAuth backend redirects to the bare origin
// (e.g. /?auth_success=false&result=account_already_exists); the "/" route
// bounces through a login redirect that drops the query string before
// NavigateToDefaultEntity can read it. If a Gmail connect is pending, persist
// the result here so EmailAccountProvider can toast it once the inbox loads.
export const captureGmailOAuthResult = () => {
  const pending = getStorageItem<{ entityId: string; createdAt: number }>(
    CRM_GMAIL_OAUTH_PENDING_REDIRECT_KEY
  );

  // leave CRM_GMAIL_OAUTH_PENDING_REDIRECT_KEY in place — NavigateToDefaultEntity
  // still needs it to route to the inbox
  if (!pending) {
    return;
  }

  const params = new URLSearchParams(window.location.search);

  saveItemToStorage(CRM_GMAIL_OAUTH_RESULT_PENDING_KEY, {
    entityId: pending.entityId,
    createdAt: pending.createdAt,
    authSuccess: params.get("auth_success"),
    result: params.get("result"),
  });
};
